export default __webpack_public_path__ + "static/media/submit-error.586d03ab.svg";